import { useState } from "react";
import { hotRank, hotChannelList } from "@/mocks/chigua";

export default function RankSection() {
  const [expanded, setExpanded] = useState(5);
  const shown = hotRank.slice(0, expanded);

  return (
    <section id="rank" className="honeycomb py-14 md:py-20">
      <div className="mx-auto grid max-w-6xl gap-10 px-4 md:px-6 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <p className="mb-2 text-xs font-medium tracking-widest text-secondary-600">HOT RANKING</p>
          <h2 className="font-display text-3xl text-foreground-950 md:text-4xl">
            吃瓜<span className="text-secondary-500">热榜</span>
          </h2>
          <p className="mt-2 text-sm text-foreground-600">热度实时刷新，围观群众最关心的话题都在这。收藏一下，蹲后续不断线。</p>

          <div className="mt-7 overflow-hidden rounded-3xl border border-background-200 bg-background-50">
            {shown.map((r, idx) => {
              const topThree = idx < 3;
              return (
                <article
                  key={r.rank}
                  className="group flex cursor-pointer items-center gap-4 border-b border-background-100 px-5 py-4 transition-colors last:border-0 hover:bg-background-100/60"
                >
                  <span
                    className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl font-display text-lg ${
                      topThree ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-500"
                    }`}
                  >
                    {r.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <h3 className="truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600 md:text-base">
                        {r.title}
                      </h3>
                      <i
                        className={`hidden shrink-0 text-sm sm:block ${
                          r.trend === "up"
                            ? "ri-arrow-up-line text-primary-500"
                            : r.trend === "down"
                            ? "ri-arrow-down-line text-accent-600"
                            : "ri-subtract-line text-foreground-400"
                        }`}
                      ></i>
                    </div>
                    <div className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                      <span className="rounded bg-secondary-50 px-1.5 py-0.5 font-medium text-secondary-700">{r.tag}</span>
                      <span>热度 {r.heat.toFixed(1)}万</span>
                    </div>
                  </div>
                  <button
                    type="button"
                    aria-label={`蹲话题${r.rank}的后续`}
                    className="hidden h-9 w-9 shrink-0 items-center justify-center rounded-full border border-background-200 text-foreground-400 transition-colors hover:border-primary-300 hover:text-primary-600 sm:flex"
                  >
                    <i className="ri-notification-3-line"></i>
                  </button>
                </article>
              );
            })}
          </div>

          <button
            type="button"
            onClick={() => setExpanded((v) => (v >= hotRank.length ? 5 : hotRank.length))}
            className="mt-4 inline-flex items-center gap-2 rounded-full border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-600 transition-colors hover:border-secondary-400 hover:text-secondary-600"
          >
            {expanded >= hotRank.length ? "收起榜单" : "展开完整榜单"}
            <i className={`${expanded >= hotRank.length ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}`}></i>
          </button>
        </div>

        <aside className="flex flex-col gap-6">
          <div className="rounded-3xl bg-accent-500 p-6 text-background-50">
            <div className="flex items-center justify-between">
              <span className="text-xs font-medium tracking-widest">LIVE</span>
              <span className="inline-flex items-center gap-1.5 text-xs">
                <span className="relative flex h-2 w-2">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-background-50 opacity-70"></span>
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-background-50"></span>
                </span>
                实时
              </span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-background-50/90">
              现在有 <strong className="text-background-50">12,486</strong> 位群众正在瓜田里蹲点，看看大家在蹲什么。
            </p>
            <div className="mt-4 flex -space-x-2">
              {[
                "https://readdy.ai/api/search-image?query=Cute%20cartoon%20avatar%20eating%20watermelon%20happy%20expression%2C%20flat%20vector%2C%20mint%20background&width=120&height=120&seq=mini-1&orientation=squarish",
                "https://readdy.ai/api/search-image?query=Cute%20cartoon%20avatar%20wearing%20sunglasses%20holding%20melon%20slice%2C%20flat%20vector%2C%20warm%20background&width=120&height=120&seq=mini-2&orientation=squarish",
                "https://readdy.ai/api/search-image?query=Cute%20cartoon%20avatar%20surprised%20with%20watermelon%20seeds%2C%20flat%20vector%2C%20cream%20background&width=120&height=120&seq=mini-3&orientation=squarish",
              ].map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt=""
                  className="h-9 w-9 rounded-full border-2 border-accent-500 object-cover"
                />
              ))}
              <span className="flex h-9 w-9 items-center justify-center rounded-full border-2 border-accent-500 bg-background-50 text-[10px] font-medium text-accent-700">
                +12k
              </span>
            </div>
          </div>

          <div className="rounded-3xl border border-background-200 bg-background-50 p-6">
            <h3 className="font-display text-xl text-foreground-950">频道此刻上新</h3>
            <div className="mt-4 flex flex-col gap-3">
              {hotChannelList.map((c) => (
                <a
                  key={c.name}
                  href="#channels"
                  className="flex items-center justify-between rounded-2xl bg-background-100 px-4 py-3 transition-colors hover:bg-accent-50"
                >
                  <div>
                    <p className="text-sm font-medium text-foreground-900">{c.name}</p>
                    <p className="mt-0.5 text-xs text-foreground-500">{c.desc}</p>
                  </div>
                  <span className="flex items-center gap-1 whitespace-nowrap rounded-full bg-accent-500 px-2.5 py-1 text-xs font-medium text-background-50">
                    +{c.today}
                  </span>
                </a>
              ))}
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}